import React from 'react';

const strategyDetails = [
  {
    title: "Start with $80/Week — Small but Consistent",
    description: "Building wealth doesn’t require big sums of money upfront. By committing as little as $80 per week or less, you can invest in high-growth assets and harness the power of compound interest. Over time, this small but consistent investment will snowball, providing you with a substantial nest egg. Think of it like planting a tree: small steps today lead to big growth tomorrow.",
    linkText: "Start Investing Today →",
    link: "https://robinhood.com/eu/en/about/crypto/"
  },
  {
    title: "Choose Low-Cost ETFs for Automatic Diversification",
    description: "ETFs allow you to diversify your portfolio without buying multiple individual stocks. By investing in ETFs like Vanguard’s Total Stock Market ETF, you’re instantly exposed to a wide range of industries. Low-cost ETFs minimize management fees, meaning more of your money works for you. Whether you're investing for growth, income, or a balanced mix, ETFs are the perfect way to build a robust portfolio over time.",
    linkText: "Find the Best ETFs →",
    link: "https://www.marketwatch.com/tools/top-25-etfs"
  },
  {
    title: "Reinvest Dividends to Maximize Growth",
    description: "Dividends aren’t just ‘extra cash’; they’re a powerful tool to grow your wealth. Instead of cashing out dividends, reinvesting them into additional shares can significantly accelerate your portfolio's growth. By doing so, you benefit from compounded returns, which means your earnings start generating even more earnings. This is how successful investors continue to grow their portfolios over time.",
    linkText: "See How Reinvestment Works →",
    link: "https://www.marketbeat.com/dividends/calculator/"
  },
  {
    title: "Use Robo-Advisors to Automate Your Investments",
    description: "Robo-advisors like Betterment and Wealthfront take the guesswork out of investing. These platforms automatically allocate your funds into a diversified portfolio that’s optimized for growth, based on your risk tolerance and goals. They offer a low-cost solution for hands-off investors, allowing you to build wealth over time without the need for expert knowledge or constant monitoring.",
    linkText: "Best Robot-Advisors",
    link: "https://www.nerdwallet.com/best/investing/robo-advisors"
  },
  {
    title: "Consider Crypto as a Small Portion of Your Portfolio",
    description: "Crypto is volatile but can offer high growth potential over time. Allocating 5-10% of your portfolio to Bitcoin or other digital assets can provide diversification and serve as a hedge against traditional markets. While the market may experience ups and downs, adding crypto to your portfolio could help balance risk and increase potential long-term returns. Remember, always invest only what you’re willing to lose, and treat it as part of your overall strategy.",
    linkText: "Explore Crypto Investments →",
    link: "https://www.coinbase.com"
  }
];

const StrategyCard = ({ title, description, linkText, link }) => (
  <div style={styles.card}>
    <h3 style={styles.cardTitle}>{title}</h3>
    <p>{description}</p>
    <a href={link} style={styles.cta}>{linkText}</a>
  </div>
);

const TwentyWeekInvesting = () => {
  return (
    <div style={styles.container}>
     
      <p style={styles.intro}>
        What if I told you that investing just $80 per week could set you on the path to financial freedom? It may seem small at first, but over time, consistent investments in the right assets can help you build a substantial portfolio. These simple strategies are perfect for anyone, whether you're just starting or looking to take your finances to the next level.
      </p>

      {strategyDetails.map((strategy, index) => (
        <StrategyCard key={index} {...strategy} />
      ))}

      <div style={styles.footer}>
        <h2 style={styles.footerTitle}>💡 Final Thought: The Power of Consistency</h2>
        <p style={styles.footerText}>
          Remember, the path to wealth doesn’t require major sacrifices or risky bets. It’s about making smart, consistent decisions and giving your investments time to grow. With the right strategies, anyone can start their journey toward financial freedom — one small step at a time.
        </p>
        <a href="#" style={styles.cta}>Start Your $80/Week Journey Now →</a>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6'
  },
  intro: {
    fontSize: '18px',
    marginBottom: '20px',
    color: '#2c3e50',
    fontWeight: '300',
    textAlign: 'center',
  },
  card: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '25px',
    backgroundColor: '#f9f9f9',
    transition: 'box-shadow 0.3s ease',
  },
  cardTitle: {
    fontSize: '1.6rem',
    color: '#2c3e50',
    marginBottom: '15px',
    fontWeight: '600',
  },
  cta: {
    display: 'inline-block',
    marginTop: '12px',
    backgroundColor: '#0070f3',
    color: '#fff',
    padding: '10px 20px',
    textDecoration: 'none',
    borderRadius: '4px',
    fontWeight: 'bold'
  },
  footer: {
    marginTop: '40px',
    backgroundColor: '#2c3e50',
    color: '#fff',
    padding: '20px',
    borderRadius: '8px',
  },
  footerTitle: {
    fontSize: '1.8rem',
    marginBottom: '10px',
  },
  footerText: {
    fontSize: '1.2rem',
    lineHeight: '1.6',
    marginBottom: '15px',
  },
};

export default TwentyWeekInvesting;

